import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Loader from '../components/loader';

function App() {

	const userType = sessionStorage.getItem("TRCUserType");
    const [employeeData, setEmployeeData] = useState('');
    const [loader, setLoader] = useState(false);
    const [error, setError] = useState(false);

	useEffect(() => {

		if(userType && userType === 'admin1'){
			window.location = '/admin-dashboard';
		}

		if(userType && userType === 'admin2'){
			window.location = '/admin-dashboard';
		}

		if(userType && userType === 'md'){
			window.location = '/admin-dashboard';
		}

		if(userType && userType === 'gm'){
			window.location = '/admin-dashboard';
		}

		if(userType && userType === 'office'){
			window.location = '/accounts-dashboard';
		}

		if(userType && userType === 'account'){
			window.location = '/accounts-dashboard';
		}

		if(userType && userType === 'sales'){
			window.location = '/sales-dashboard';
		}
	},[userType]);

    const newData = (e) => {
        const { name, value } = e.target;
        setEmployeeData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
    };

    const addEmployee = async (e) => {
		setLoader(true);
		setError(false);
		e.preventDefault();
		try {
			const response = await axios.post('https://api.trucoo.in/authorization/', employeeData, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});

            console.log(response.data);

			if(response.data.status === 'success'){
				
                sessionStorage.setItem("TRCUserId", response.data.data.id);
                sessionStorage.setItem("TRCUserEmail", response.data.data.companyEmail);
                sessionStorage.setItem("TRCUserName", response.data.data.employeeName);
                sessionStorage.setItem("TRCUserPosition", response.data.data.position);
                sessionStorage.setItem("TRCUserType", response.data.data.employeeType);
				
				if(response.data.data.employeeType === 'admin1'){
					window.location = '/admin-dashboard';
				}

                if(response.data.data.employeeType === 'admin2'){
					window.location = '/admin-dashboard';
				}

				if(response.data.data.employeeType === 'md'){
					window.location = '/admin-dashboard';
				}

				if(response.data.data.employeeType === 'gm'){
					window.location = '/admin-dashboard';
				}

				if(response.data.data.employeeType === 'office'){
					window.location = '/accounts-dashboard';
				}

				if(response.data.data.employeeType === 'account'){
					window.location = '/accounts-dashboard';
				}

				if(response.data.data.employeeType === 'sales'){
					window.location = '/sales-dashboard';
				}
                
			}else{
				setError(response?.data?.error?.message);
			}
	
			
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}

		setLoader(false);
	};

    //console.log(employeeData);

return(

<div class="container h-p100" style={{marginTop:'25vh'}}>
	{loader && <Loader /> }
		<div class="row align-items-center justify-content-md-center h-p100">	
			
			<div class="col-12">
				<div class="row justify-content-center g-0">
					<div class="col-lg-5 col-md-5 col-12">
						<div class="bg-white rounded10 shadow-lg">
							<div class="content-top-agile p-20 pb-0">
								<h2 class="text-primary fw-600">Let's Get Started</h2>
								<p class="mb-0 text-fade">Sign in to continue to Trucoo.</p>							
							</div>
							<div class="p-40">
								<form onSubmit={addEmployee}>
									<div class="form-group">
										<div class="input-group mb-3">
											<span class="input-group-text bg-transparent"><i class="text-fade ti-email"></i></span>
											<input type="email" class="form-control ps-15 bg-transparent" placeholder="Email" name="email" value={employeeData.email} onChange={(e)=>newData(e)} required />
										</div>
									</div>
									<div class="form-group">
										<div class="input-group mb-3">
											<span class="input-group-text  bg-transparent"><i class="text-fade ti-lock"></i></span>
											<input type="password" class="form-control ps-15 bg-transparent" placeholder="Password" name="password" value={employeeData.password} onChange={(e)=>newData(e)} required />
										</div>
									</div>
									  <div class="row">
										<div class="col-12 text-center">
										  <button type="submit" class="btn btn-primary w-p100 mt-10">SIGN IN</button>
										</div>
										
									  </div>
								</form>	
								<div class="text-center">
									{error && <p class="text-danger mt-15 mb-0">{error}</p>}
									<p class="mt-15 mb-0 text-fade">Forgot password? <a href="/" class="text-primary ms-5">Reset Now</a></p>
								</div>
								
								
							</div>						
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

);
}

export default App;